import { LastActivityType } from '@/modules/group/modules/groups/domain/models/LastActivityType'

import { axios, Response } from '../index'

const lastActivityPatientId = (
  patientId: string
): Response<LastActivityType[]> => {
  return axios.get(`/v1/patient/${patientId}/last-activity`)
}

export default lastActivityPatientId
